import { ISchedulePattern } from '../../../../app/entities/SchedulePattern'

/**
 * Determines the active schedule pattern for a technician.
 * Active pattern = the most recently created pattern (by created timestamp)
 * 
 * SIMPLIFIED LOGIC: No more date-based filtering. The newest pattern is always active.
 * effectiveFrom only matters at creation time to determine which day settings to regenerate.
 *
 * @param schedulePatterns - Array of schedule patterns for a technician
 * @returns The most recently created schedule pattern, or null if none found
 */
export function getActiveSchedulePattern(
  schedulePatterns: ISchedulePattern[],
): ISchedulePattern | null {
  if (!schedulePatterns || schedulePatterns.length === 0) {
    return null
  }

  // Sort by created timestamp descending (most recent first) and take the first one
  const sortedPatterns = schedulePatterns.sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime(),
  )

  return sortedPatterns[0]
}
